import { useSelectSettings } from '../../selectors';
import { setSettings as setSettingsAction } from '../../actions/app.actions';
import { useDispatch } from 'react-redux';
import React from 'react';
import type { CompanySettings, Settings } from 'types';
import UnitsProvider from '../../contexts/Settings/Units';

export const useSettings = () => {
	const dispatch = useDispatch();
	const _settings = useSelectSettings();

	const setSettings = React.useCallback(
		(settings: Omit<Settings, 'settingsLoaded'> | CompanySettings) => {
			// The old setSettings worked by sending CompanySettings so, some apps send settings in a different shape

			const s =
				'companySettings' in settings
					? settings
					: ({ companySettings: settings } as unknown as Settings);

			dispatch(setSettingsAction(s));
		},
		[],
	);

	return { ..._settings, setSettings };
};

interface SettingsProviderProps {
	children: React.ReactElement;
}

/**
 * Company Settings provider
 *
 * Falls back to US defaults
 */
export const SettingsProvider = ({
	children,
}: SettingsProviderProps): JSX.Element => {
	// Company settings are now loaded by useInitialization (runDataStep);
	// this provider just exposes them and the units context.
	const { companySettings } = useSettings();

	return (
		<UnitsProvider system={companySettings.UOM}>{children}</UnitsProvider>
	);
};

export default SettingsProvider;
